import React from "react";

export default function Tips() {
  return (
    <app-tips-and-previews
      _ngcontent-ng-c3019720824=""
      _nghost-ng-c1037383007=""
    >
      {/**/}
      <div _ngcontent-ng-c1037383007="" className="container-fluid mt-2">
        <div _ngcontent-ng-c1037383007="" className="row ng-star-inserted">
          <div _ngcontent-ng-c1037383007="" className="col-12 newsContainer">
            <div _ngcontent-ng-c1037383007="" className="card">
              <div
                _ngcontent-ng-c1037383007=""
                className="card-header newsHeader"
              >
                NEWS
              </div>
              <div _ngcontent-ng-c1037383007="" className="card-body p-0">
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/cb571659-2e12-4a12-bdf4-ed8c5dd937b5.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            Premier League: Man City draws against 10-man
                            Arsenal as Stones scores stoppage time equaliser
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            {" "}
                            John Stones scored deep in injury time as Manchester
                            City salvaged a 2-2 draw with 10-man Arsenal on
                            Sunday to remain top of the Premier League table
                            after a rip-roaring battle against its bitter title
                            rival. The draw in what was more of a slugfest than
                            a chess match left Pep Guardiola’s men with 13
                            points after five matches, while Mikel Arteta’s
                            Arsenal is fourth with 11. Erling Haaland put City
                            ahead in the ninth minute when Savinho threaded a
                            beautiful through ball that the big Norwegian
                            sprinted onto and then slotted past David Raya. AS
                            IT HAPPENED: Manchester City vs Arsenal highlights
                            Ricardo Calafiori cancelled out Haaland’s goal with
                            his first for Arsenal, a screamer from about 20
                            metres out in the 22nd minute. Arsenal had caught
                            City unprepared with a free kick in the lead-up, as
                            Guardiola karate-kicked his chair. Gabriel put the
                            visitors ahead in first-half injury time when he
                            darted in to leap high and head home Bukayo Saka’s
                            corner. Arsenal was reduced to 10 men when Leandro
                            Trossard was shown a second yellow and sent off just
                            before halftime for kicking the ball away and
                            delaying the restart. It looked poised for its first
                            win at the Etihad Stadium since 2015 before Stones
                            prodded in from close range in the 98th minute.
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/49546de0-9029-4dc9-a672-adb415b9f562.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            Laver Cup 2024: Tiafoe beats Medvedev as Team World
                            goes ahead
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            Frances Tiafoe put Team World ahead at the Laver Cup
                            with a victory over Daniil Medvedev on Saturday. The
                            American, who reached the semifinals at the U.S.
                            Open, won 3-6, 6-4 and 10-5 in the third set, which
                            is a match tiebreaker. Each match win is worth two
                            points on Saturday and three points on Sunday. The
                            first team to 13 points wins in a format reminiscent
                            of golf’s Ryder Cup. Wins were worth one point on
                            Friday. ALSO READ: Korea Open: Kasatkina to battle
                            Haddad Maia in final clash Tiafoe’s victory gave his
                            side a 4-2 lead over Team Europe ahead of Carlos
                            Alcaraz’s match against American Ben Shelton.
                            Afterwards, Germany’s Alexander Zverev faces Taylor
                            Fritz of the United States. The final match of the
                            day is doubles with European pair Casper Ruud and
                            Stefanos Tsitsipas facing Ben Shelton and Alejandro
                            Tabilo.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/64897cb3-0508-4bde-a4c5-49b2f8493638.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            Rafael Nadal included in Spain team for Davis Cup
                            Final Eight clash
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            Rafael Nadal has been named in Spain’s team for the
                            Davis Cup Final Eight match in Malaga in November.
                            The 22-time Grand Slam champion has not competed
                            anywhere since the Paris 2024 Olympics, where he
                            lost in the second round to rival Novak Djokovic in
                            the men’s singles, and paired with Carlos Alcaraz to
                            get to the quarterfinals of men’s doubles before
                            exiting against Americans Austin Krajicek and Rajeev
                            Ram. Following the Paris Games, Nadal pulled out of
                            the US Open 2024 and Laver Cup 2024 due to health
                            issues. He will be joining Alcaraz, Roberto Bautista
                            Agut, Pablo Carreno Busta and Marcel Granollers in
                            the Spain team. David Ferrer will be the coach for
                            the team. The top eight nations qualified from the
                            Group Finals and will play to a finish in the
                            Spanish coastal city. Host Spain will face the
                            Netherlands while Canada is up against Germany in
                            its opening tie. Ties will consist of two singles
                            and a doubles decider. ALSO READ | Bhambri-Olivetti
                            pair reaches Chengdu Open Final;
                            Prashanth-Nedunchezhiyan win in Hangzhou semifinals
                            Reigning champion Italy was without world number one
                            Jannik Sinner for the Group Finals in which it won
                            all three of its ties but the world number one could
                            return in Malaga. It will face Argentina, who
                            qualified from a tough group including Britain and
                            Canada. Italy and Spain are on opposite sides of the
                            draw meaning a potential final showdown between
                            Sinner and third-ranked Carlos Alcaraz. The U.S. was
                            also under-strength in the Group Finals but the
                            32-times Davis Cup champion could call on some of
                            its big guns in Malaga where it will need to get
                            past Australia, the second most successful nation
                            with 28 titles. The Final Eight knockout rounds take
                            place between November 19-24 in the Palacio de
                            Deportes Jose Maria Martin Carpena.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/0bbb5c53-0e08-4cfb-86d2-d8c87ddc1910.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            King Cup of Champions: Boushal scores stoppage-time
                            winner for Al Nassr to beat Al Hazm 2-1
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            {" "}
                            Nawaf Boushal scored in the second minute of
                            stoppage time of the game for Al Nassr as it beat Al
                            Hazm and made it to round of 16 of the King Cup of
                            Champions at the King Abdullah Sports City Stadium.
                            The first goal came in the 45+6’ minute as Sadio
                            Mane headed the ball into the net courtesy of a
                            cross from the right wing from Sultan al Ghannam. In
                            the second half in the 62nd minute, Basil Yousef
                            Alsayyali scored in fine fettle to level the game
                            again. Karim Yoda got a long ball on the right wing
                            as he squared it into the box for Alsayyali whose
                            shot struck the crossbar and bounced into the net.
                            Right before the end of regulation time Boushal
                            netted the winner to ensure Nassr goes through ahead
                            in the King’s Cup. Nassr will be hoping to do better
                            in the tournament since it reached the final last
                            season but lost to rival club Al Hilal. ALSO READ |
                            Manchester City’s injured Kevin De Bruyne should be
                            back soon, says Pep Guardiola Al Nassr was without
                            Cristiano Ronaldo in the squad tonight but will most
                            likely feature in the Saudi Pro League matches
                            ahead. Nassr is fifth in the league table with two
                            wins and to draws and faces Al Wehda FC in the Saudi
                            Pro League on September 27.
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/900bba80-d414-4cd7-ba59-aa88d2c19d77.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            AFG vs SA: South Africa wins third ODI, denies
                            Afghanistan series sweep
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            South Africa denied Afghanistan a series sweep with
                            a seven-wicket win in the third and final ODI on
                            Sunday. Aiden Markram’s unbeaten 69 led South Africa
                            to 170-3 with 17 overs to spare after Afghanistan
                            collapsed for the first time in the series and was
                            bowled out for 169 in 34 overs. An inexperienced
                            South Africa was dismissed for 106 and 134 in the
                            first two games, but Markram paced the chase well on
                            yet another slow wicket at Sharjah Cricket Stadium
                            with a gritty 67-ball innings. Earlier, Rahmanullah
                            Gurbaz, who made a century in the last game, held
                            the innings together by contributing 89 runs in 94
                            balls after Afghanistan chose to bat first. But none
                            of the other top eight Afghan batters could score
                            more than 10 with three of them run out. No. 9
                            batter AM Ghazanfar made a whirlwind 31 off 15 but
                            South Africa always looked in control through the
                            disciplined bowling of Lungi Ngidi, Nqabayomzi Peter
                            and Andile Phehlukwayo, who all picked up two
                            wickets each.
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/b4d7ce8c-f0a4-4f27-b2b2-7ca350603c8c.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            SL vs NZ: Jayasuriya steers Sri Lanka to 63-run win
                            over New Zealand in first Test
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            {" "}
                            Left-arm spinner Prabath Jayasuriya took two overs
                            to polish off the New Zealand tail and complete a
                            five-wicket haul as Sri Lanka sealed a 63-run
                            victory in the opening Test at Galle International
                            Stadium on Monday. Chasing 275 for victory, New
                            Zealand was all out for 211 despite Rachin
                            Ravindra’s gallant 92, its batters unable to
                            negotiate the sharp turn and low bounce at the
                            venue. Jayasuriya (5-68) claimed his eighth
                            five-wicket haul, seven of them coming at his happy
                            hunting ground in Galle alone. “The win in England
                            boosted our morale,” home captain Dhananjaya de
                            Silva said referring to its Test match victory at
                            The Oval earlier this month. Also read | How
                            Anantapur shaped New Zealand batter Rachin Ravindra
                            for success “We’ve the ability to win Tests and the
                            boys are delivering now.” New Zealand began the
                            final day needing 68 runs for a memorable win with
                            two wickets in hand but Sri Lanka took only four
                            overs to wrap up victory. New Zealand’s slim chances
                            evaporated in the second over of the day when
                            Jayasuriya ended Ravindra’s stellar knock, which
                            included nine fours and a six. The batter reviewed
                            the lbw decision more in desperation than anything
                            else and replays confirmed Ravindra was plumb in
                            front. Jayasuriya bowled William O’Rourke in his
                            next over to seal Sri Lanka’s victory, beating the
                            batter’s defensive prod at an arm ball. “Tough place
                            to come but a good test match throughout,” New
                            Zealand captain Tim Southee said. “There’s plenty of
                            positives for us to take away from it but obviously
                            disappointing to come out on the wrong side.”
                            Jayasuriya’s match haul of nine wickets earned him
                            the player of the match award, while Ramesh Mendis
                            claimed three second-innings wickets. “I like this
                            Galle pitch,” Jayasuriya said. “I just concentrate
                            on bowling a consistent line and length, focus on
                            that and get the results.” The second Test, also in
                            Galle, begins on Thursday.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/88df56a5-dbc2-42ef-aa9f-ec1f138c0f98.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            Korea Open: Haddad Maia fights back after first set
                            loss to beat Kasatkina in final
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            {" "}
                            U.S. Open quarterfinalist Beatriz Haddad Maia
                            overcame first-set jitters in the Korea Open final
                            to beat top seed Daria Kasatkina 1-6, 6-4, 6-1,
                            winning the first WTA 500 singles title of her
                            career on Sunday. Haddad Maida, who lost the final
                            in Seoul in 2017, bounced back in the second set
                            with lethal forehands that brushed the lines and
                            cruised through the third set to secure her first
                            title of the year. “Another tough match... Hope we
                            have many more to come,” Kasatkina told Haddad Maia
                            after losing her second match to the Brazilian,
                            having won their first two clashes. Russian world
                            number 13 Kasatkina won five games in a row to
                            clinch the first set in just 26 minutes as third
                            seed Haddad Maida struggled with her serves, winning
                            only nine of her 20 service points. Kasatkina broke
                            on the first game of the second set but Haddad Maia
                            put up a better fight, getting her first break of
                            the match to make it 3-3, making a frustrated
                            Kasatkina chase her returns to the ends of the
                            court. ALSO READ: Laver Cup 2024: Team World takes
                            lead as Ruud, Tsitsipas fall in doubles World number
                            17 Haddad Maia saved a crucial break point to take a
                            5-4 lead, looking increasingly comfortable in long
                            rallies. She broke in the next game to secure the
                            second set with a strong forehand. A transformed
                            Haddad Maia was in control in the decisive set,
                            winning 17 of her 22 service points and breaking
                            twice in a row to secure victory. “I want to come
                            back again next year,” the 28-year-old said after
                            winning her fourth WTA singles title.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/0fe008e2-b325-4b0a-a0dd-7db11f667bcc.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            La Liga 2024-25: Kylian Mbappe strikes again as Real
                            Madrid beats Deportivo Alaves 3-2
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            Kylian Mbappe struck for the fourth consecutive game
                            as Real Madrid survived a late scare to beat
                            Deportivo Alaves 3-2 in the La Liga 2024-25 match at
                            the Santiago Bernabeu Stadium on Wednesday. Los
                            Blancos, second, cut the gap on Barcelona down to
                            one point before the leader hosts Getafe on
                            Wednesday. Madrid dismantled Alaves with goals from
                            Lucas Vazquez, Mbappe and Rodrygo before a late
                            salvo from the visitor rocked Carlo Ancelotti’s side
                            when it thought the game was won. Carlos Benavidez
                            Protesoni and Kike Garcia scored two goals in two
                            minutes in the final stages but Madrid held on for
                            the victory. Los Blancos overpowered Alaves from the
                            start in what was a hugely uneven contest for most
                            of the game, despite the Basque side’s solid start
                            to the season. Ancelotti brought Vinicius Junior
                            back into the starting line-up and gave Vazquez a
                            rare start and the pair combined inside the first
                            minute to send Madrid ahead. The Brazilian winger
                            surged in from the left flank and cut the ball back
                            for a simple finish from Vazquez. Ancelotti said
                            Monday he wanted more intensity from his team at the
                            outset of matches after Madrid had scored just one
                            first-half goal this season in La Liga or the
                            Champions League, and his demand was swiftly met. AS
                            IT HAPPENED | REAL MADRID VS ALAVES HIGHLIGHTS, LA
                            LIGA 2024-25 Los Blancos dominated with Alaves
                            barely reaching Thibaut Courtois’ penalty box.
                            Despite that Madrid’s second goal only came five
                            minutes before the interval, when Mbappe and Jude
                            Bellingham combined beautifully. Fifth league goal
                            for Mbappe France captain Mbappe conjured a clever
                            flicked pass to the England international, who
                            completed a one-two by sending his team-mate through
                            on goal. Mbappe took two deft touches to shake his
                            marker and get a sight of goal, before stroking home
                            clinically for his fifth league goal. Rodrygo
                            expanded Madrid’s lead soon after the interval,
                            roaming in with freedom from the right and firing
                            through Alaves goalkeeper Antonio Sivera’s legs.
                            Teenage Brazilian striker Endrick hit the post with
                            a deflected effort and Abde Rebbach also struck the
                            woodwork as Alaves made a rare foray forward.
                            Endrick was fortunate not to be dismissed when he
                            kicked out at Alaves defender Santiago Mourino. The
                            visitor pulled one back after 85 minutes when
                            Protesoni curled home a sweet strike from the edge
                            of the box. Protesoni then turned provider with a
                            fine ball over the top which Kike Garcia fired home
                            well. Madrid hung on for the victory, its 39th
                            consecutive league game unbeaten, ahead of Sunday’s
                            derby clash with Atletico Madrid at the
                            Metropolitano. The Rojiblancos’ stadium was where it
                            last tasted defeat in the top flight, exactly a year
                            ago{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  _ngcontent-ng-c1037383007=""
                  className="p-2 mainNews ng-star-inserted"
                >
                  <a _ngcontent-ng-c1037383007="">
                    <div _ngcontent-ng-c1037383007="" className="d-flex">
                      <div _ngcontent-ng-c1037383007="" className="width-img">
                        <img
                          _ngcontent-ng-c1037383007=""
                          className="NewsImg"
                          src="http://market.mgmopr.com/api/trader/tips/images/bbc508f4-20e4-420e-bc6b-46b1c58d9bd1.jpg"
                        />
                      </div>
                      <div
                        _ngcontent-ng-c1037383007=""
                        className="width-content"
                      >
                        <div _ngcontent-ng-c1037383007="">
                          <h2
                            _ngcontent-ng-c1037383007=""
                            className="news-heading"
                          >
                            ENG vs AUS: Brook’s century keeps England’s series
                            hopes alive, breaks Australia’s ODI-winning streak
                          </h2>
                          <p
                            _ngcontent-ng-c1037383007=""
                            className="news-description mt-1"
                          >
                            England captain Harry Brook struck his first one-day
                            international century before his team clinched a
                            46-run win by the DLS method to keep alive the
                            series against Australia on Tuesday. Chasing 305 to
                            win the third ODI, England was 254-4 — with Brook
                            unbeaten on 110 — when heavy rain arrived in the
                            day-nighter at Chester-le-Street. The teams didn’t
                            get back on the field and England was well ahead of
                            the run-rate. Australia, which had cruised to
                            dominant wins at Southampton and Leeds in this
                            five-match series, saw its lead trimmed to 2-1 and
                            its 14-match winning run in ODIs come to an end.
                            During that streak, the team won the Cricket World
                            Cup in India last year. Coming to the crease with
                            England in trouble on 11-2, Brook took on
                            Australia’s seam attack by hitting 13 fours and two
                            sixes in a 94-ball knock to easily surpass his
                            previous ODI-best score of 80. The series continues
                            on Friday with the fourth ODI at Lord’s. Playing
                            without explosive opener Travis Head (rested) and
                            star spinner Adam Zampa (ill), Australia was put
                            into bat and needed a strong finish — mainly thanks
                            to Alex Carey’s unbeaten 77 and No. 8 batter Aaron
                            Hardie’s 44 off 26 — to post 304-7 off its 50 overs.
                            Also read | Shaheen Shah Afridi returns to 15-member
                            Pakistan squad for first Test against England Steve
                            Smith hit a patient 60 off 82 balls, after the
                            tourist’s innings was slowed by losing Cameron Green
                            (42) and Marnus Labuschagne (0) in space of five
                            balls just past the halfway mark. It looked a tough
                            chase for a youthful England team that had been
                            outclassed so far this series and things started
                            badly when Mitchell Starc dismissed Phil Salt (for
                            an eight-ball duck) and Ben Duckett (8) in the same
                            over — Australia’s third. Brook, once again standing
                            in as captain for the injured Jos Buttler, embraced
                            the pressure of the occasion and went on the attack
                            pretty much from the start of his innings. His
                            third-wicket stand of 156 with Will Jacks (84 off 82
                            balls) swung the momentum England’s way and the team
                            maintained it when the big-hitting Liam Livingstone
                            came in at No. 6 and immediately smashed two sixes.
                            Brook used the uppercut to great effect to deal with
                            some short-pitched bowling from the Australians and
                            hit a straight drive for four to get to 99. Off the
                            next ball, he opened the face and edged for another
                            four to reach his century, prompting him to remove
                            his helmet and look to the sky. Brook’s second fifty
                            came off just 33 deliveries. England’s push for
                            victory was then held up by the rain that arrived in
                            the 38th over. It got heavier and heavier, with the
                            Duckworth-Lewis-Stern formula showing that the host
                            was well in front of the run-rate.
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                {/**/}
              </div>
            </div>
          </div>
        </div>
        {/**/}
        {/**/}
      </div>
    </app-tips-and-previews>
  );
}
